/**
 * @var {object} dataLayer 
 */
const pageData = window.digibordDataLayerPageData;

function digibordDataLayer() {
  if (window.dataLayer && window.dataLayer.push) {
    console.log("[digibordDataLayer]", arguments);
    dataLayer.push(arguments)
  } else {
    console.log("[digibordDataLayer] dataLayer not found");
  }
}

if (pageData.page_type === "page") {
  function viewItemList() {
    const products = document.querySelectorAll('[data-is-product]');
    if (products.length === 0) return;

    const itemList = [...products].map(product => {
      return JSON.parse(product.dataset.meta);
    });

    digibordDataLayer("event", "view_item_list", {
      items: itemList
    })
  }

  function selectItem() {
    const products = document.querySelectorAll('[data-is-product]');
    if (products.length === 0) return;

    products.forEach(product => {
      product.addEventListener("click", () => {
        const meta = JSON.parse(product.dataset.meta);
        digibordDataLayer("event", "select_item", {
          items: [meta]
        })
      });
    })
  }

  function trackAddToCartAjax() {
    const products = document.querySelectorAll('[data-is-product]');
    if (products.length === 0) return;

    products.forEach(product => {
      const addToCartButton = product.querySelector('a.single_add_to_cart_button');
      if (!addToCartButton) return;

      addToCartButton.addEventListener("click", () => {
        const meta = JSON.parse(product.dataset.meta);
        const price = Number(product.dataset.price);

        digibordDataLayer("event", "add_to_cart", {
          currency: "EUR",
          value: price,
          items: [meta]
        })
      });
    })
  }

  viewItemList()
  selectItem()
  trackAddToCartAjax()
}


if (pageData.page_type === "product") {
  function viewItem() {
    const product = document.querySelector('[data-is-single-product]');
    if (!product) return;
    const meta = JSON.parse(product.dataset.meta);
    const price = Number(product.dataset.price);

    digibordDataLayer("event", "view_item", {
      currency: "EUR",
      value: price,
      items: [meta]
    })
  }

  function addToCart() {
    const product = document.querySelector('[data-is-single-product]');
    if (!product) return;
    const addToCartButton = product.querySelector('button[name=add-to-cart]');
    if (!addToCartButton) return;

    addToCartButton.addEventListener("click", () => {
      const quantityEl = product.querySelector('input[name=quantity]');
      if (!quantityEl) return;

      const meta = JSON.parse(product.dataset.meta);
      const price = Number(product.dataset.price);
      const quantity = Number(quantityEl.value);

      meta.quantity = quantity;

      digibordDataLayer("event", "add_to_cart", {
        currency: "EUR",
        value: price * quantity,
        items: [meta]
      })
    });
  }

  viewItem();
  addToCart();
}

if (pageData.page_type === "cart") {
  function viewCart() {
    const products = document.querySelectorAll('[data-is-cart-item]');
    if (products.length === 0) return;

    const value = [...products].reduce((acc, product) => {
      const price = Number(product.dataset.price);
      const quantity = Number(product.dataset.quantity);
      return acc + (price * quantity);
    }, 0);

    const itemList = [...products].map(product => {
      const data = JSON.parse(product.dataset.meta);
      data.quantity = Number(product.dataset.quantity);
      data.price = Number(product.dataset.price) * Number(product.dataset.quantity);
      return data;
    })

    digibordDataLayer("event", "view_cart", {
      currency: "EUR",
      value: value,
      items: itemList
    })
  }

  function removeFromCart() {
    const products = document.querySelectorAll('[data-is-cart-item]');
    if (products.length === 0) return;

    products.forEach(product => {
      const removeButton = product.querySelector('a.remove');
      if (!removeButton) return;

      removeButton.addEventListener("click", () => {
        const meta = JSON.parse(product.dataset.meta);
        const price = Number(product.dataset.price);
        const quantity = Number(product.dataset.quantity);

        digibordDataLayer("event", "remove_from_cart", {
          currency: "EUR",
          value: price * quantity,
          items: [meta]
        })
      });
    })
  }

  viewCart()
  removeFromCart()
}


if (pageData.page_type === "checkout") {
  function beginCheckout() {
    const container = document.querySelector('[data-review-order]');
    if (!container) return;
    const products = container.querySelectorAll('[data-is-cart-item]');
    if (products.length === 0) return;
    const value = [...products].reduce((acc, product) => {
      const price = Number(product.dataset.price);
      const quantity = Number(product.dataset.quantity);
      return acc + (price * quantity);
    }, 0);

    const itemList = [...products].map(product => {
      const data = JSON.parse(product.dataset.meta);
      data.quantity = Number(product.dataset.quantity);
      data.price = Number(product.dataset.price) * Number(product.dataset.quantity);
      return data;
    })

    digibordDataLayer("event", "begin_checkout", {
      currency: "EUR",
      value: value,
      items: itemList
    })
  }

  function shipping() {
    const button = document.querySelector('#collapseTwo .toshipping');
    if (!button) return;

    button.addEventListener("click", () => {
      const container = document.querySelector('[data-review-order]');
      if (!container) return;
      const products = container.querySelectorAll('[data-is-cart-item]');
      if (products.length === 0) return;
      const value = [...products].reduce((acc, product) => {
        const price = Number(product.dataset.price);
        const quantity = Number(product.dataset.quantity);
        return acc + (price * quantity);
      }, 0);

      const itemList = [...products].map(product => {
        const data = JSON.parse(product.dataset.meta);
        data.quantity = Number(product.dataset.quantity);
        data.price = Number(product.dataset.price) * Number(product.dataset.quantity);
        return data;
      })

      const shippingTier = document.querySelector('.shipping_method:checked').parentElement.querySelector('label').innerText;

      digibordDataLayer("event", "add_shipping_info", {
        currency: "EUR",
        value: value,
        shipping_tier: shippingTier,
        items: itemList,
      })
    })
  }

  var config = { attributes: false, childList: true };
  var observer = new MutationObserver(payment);
  observer.observe(document.querySelector('#order_review'), config);

  function onInputChange() {
    const container = document.querySelector('[data-review-order]');
    if (!container) return;
    const products = container.querySelectorAll('[data-is-cart-item]');
    if (products.length === 0) return;
    const value = [...products].reduce((acc, product) => {
      const price = Number(product.dataset.price);
      const quantity = Number(product.dataset.quantity);
      return acc + (price * quantity);
    }, 0);

    const itemList = [...products].map(product => {
      return JSON.parse(product.dataset.meta);
    })

    const paymentMethod = document.querySelector('input[name=payment_method]:checked').parentElement.querySelector('label').innerText;

    digibordDataLayer("event", "add_payment_info", {
      currency: "EUR",
      value: value,
      payment_type: paymentMethod,
      items: itemList,
    })
  }

  let listeners = [];
  function payment() {
    listeners.forEach((el) => el.removeEventListener("change", onInputChange));
    const inputs = document.querySelectorAll('input[name="payment_method"]');
    if (!inputs) return;

    console.log("we reattach listseners");
    inputs.forEach(input => {
      input.addEventListener("change", onInputChange);
      listeners.push(input)
    })
  }


  beginCheckout();
  shipping()
  payment()
}

if (pageData.page_type === "thankyou") {

  console.log("thankyou page");

  function purchase() {
    const products = document.querySelectorAll('.order_item');
    console.log(products);
    if (products.length === 0) return;

    const value = [...products].reduce((acc, product) => {

      console.log("product", product.dataset);
      const price = Number(product.dataset.price);
      const quantity = Number(product.dataset.quantity);
      return acc + (price * quantity);
    }, 0);

    console.log("value", value);

    const itemList = [...products].map(product => {
      const data = JSON.parse(product.dataset.meta);
      data.quantity = Number(product.dataset.quantity);
      data.price = Number(product.dataset.price) * Number(product.dataset.quantity);
      return data;
    })

    console.log("itemList", itemList);

    const orderNr = document.querySelector('.order_item .order_item-number').innerText;

    console.log("orderNr", orderNr);

    digibordDataLayer("event", "purchase", {
      transaction_id: orderNr,
      affiliation: "Digibord-Shop",
      value: value,
      currency: "EUR",
      items: itemList,
    })
  }

  function onPageLoad() {
    // Check if the flag exists in the local storage
    var isFirstLoad = sessionStorage.getItem('isFirstLoad');
    purchase();
    // if (!isFirstLoad) {
    //   // Execute your function


    //   // Set the flag in local storage to indicate that the function has been executed
    //   sessionStorage.setItem('isFirstLoad', true);
    // }
  }

  window.addEventListener('load', onPageLoad);
}

